const initialBookings = [
  { id: 1, bookingId: '#BK1245', name: 'Emma Watson', email: 'emma.watson@gmail.com', avatar: `${process.env.PUBLIC_URL}/images/avatar-emma.svg`, venueImg: `${process.env.PUBLIC_URL}/images/venue-grand-bistro.svg`, venue: 'The Grand Bistro', venueLocation: 'New York, USA', date: '31 May 2024', time: '07:00 PM', status: 'Upcoming' },
  { id: 2, bookingId: '#BK1245', name: 'John Doe', email: 'johndoe@gmail.com', avatar: `${process.env.PUBLIC_URL}/images/avatar-john.svg`, venueImg: `${process.env.PUBLIC_URL}/images/venue-skyline-cafe.svg`, venue: 'Skyline Cafe', venueLocation: 'New York, USA', date: '28 May 2024', time: '07:00 PM', status: 'Upcoming' },
  { id: 3, bookingId: '#BK1245', name: 'Sophia Brown', email: 'sophiabrown@gmail.com', avatar: `${process.env.PUBLIC_URL}/images/avatar-sophia.svg`, venueImg: `${process.env.PUBLIC_URL}/images/venue-oceanview-cafe.svg`, venue: 'Oceanview Cafe', venueLocation: 'New York, USA', date: '26 May 2024', time: '07:00 PM', status: 'Completed' },
  { id: 4, bookingId: '#BK1245', name: 'Michael Smith', email: 'michael@gmail.com', avatar: `${process.env.PUBLIC_URL}/images/avatar-michael.svg`, venueImg: `${process.env.PUBLIC_URL}/images/venue-sunset-lounge.svg`, venue: 'Sunset Lounge', venueLocation: 'New York, USA', date: '25 May 2024', time: '07:00 PM', status: 'Cancelled' },
  { id: 5, bookingId: '#BK1245', name: 'Olivia Davis', email: 'oliviadavis@gmail.com', avatar: `${process.env.PUBLIC_URL}/images/avatar-olivia.svg`, venueImg: `${process.env.PUBLIC_URL}/images/venue-bella-italia.svg`, venue: 'Bella Italia', venueLocation: 'New York, USA', date: '20 May 2024', time: '07:00 PM', status: 'Completed' },
  { id: 6, bookingId: '#BK1245', name: 'Daniel Johnson', email: 'danieljohnson@gmail.com', avatar: `${process.env.PUBLIC_URL}/images/avatar-daniel.svg`, venueImg: `${process.env.PUBLIC_URL}/images/venue-roof-top.svg`, venue: 'The Roof Top', venueLocation: 'New York, USA', date: '18 May 2024', time: '07:00 PM', status: 'Upcoming' },
  { id: 7, bookingId: '#BK1245', name: 'Emma Watson', email: 'emma.watson@gmail.com', avatar: `${process.env.PUBLIC_URL}/images/avatar-emma.svg`, venueImg: `${process.env.PUBLIC_URL}/images/venue-harbor-view.svg`, venue: 'Harbor View', venueLocation: 'New York, USA', date: '16 May 2024', time: '07:00 PM', status: 'Completed' },
  { id: 8, bookingId: '#BK1245', name: 'Emma Watson', email: 'emma.watson@gmail.com', avatar: `${process.env.PUBLIC_URL}/images/avatar-emma.svg`, venueImg: `${process.env.PUBLIC_URL}/images/venue-grand-bistro.svg`, venue: 'The Grand Bistro', venueLocation: 'New York, USA', date: '14 May 2024', time: '07:00 PM', status: 'Cancelled' },
  { id: 9, bookingId: '#BK1245', name: 'William Taylor', email: 'williamtaylor@gmail.com', avatar: `${process.env.PUBLIC_URL}/images/avatar-william.svg`, venueImg: `${process.env.PUBLIC_URL}/images/venue-la-bella-vista.svg`, venue: 'La Bella Vista', venueLocation: 'New York, USA', date: '11 May 2024', time: '07:00 PM', status: 'Upcoming' },
  { id: 10, bookingId: '#BK1245', name: 'Emma Watson', email: 'emma.watson@gmail.com', avatar: `${process.env.PUBLIC_URL}/images/avatar-emma.svg`, venueImg: `${process.env.PUBLIC_URL}/images/venue-grand-bistro.svg`, venue: 'The Grand Bistro', venueLocation: 'New York, USA', date: '12 May 2024', time: '07:00 PM', status: 'Completed' },
  { id: 11, bookingId: '#BK1245', name: 'Emma Watson', email: 'emma.watson@gmail.com', avatar: `${process.env.PUBLIC_URL}/images/avatar-emma.svg`, venueImg: `${process.env.PUBLIC_URL}/images/venue-spice-circle.svg`, venue: 'Spice Circle', venueLocation: 'New York, USA', date: '10 May 2024', time: '07:00 PM', status: 'Cancelled' },
];

export default function Booking() {
  return (
    <div className="booking-page main-bg-top">
      <div className="users-header">
        <h2>All Bookings</h2>
      </div>

      <div className="users-table-wrap">
        <table className="users-table booking-table">
          <thead>
            <tr>
              <th>Booking ID</th>
              <th>User</th>
              <th>Venue</th>
              <th>Date & Time</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {initialBookings.map((b) => (
              <tr key={b.id}>
                <td className="booking-id-cell">{b.bookingId}</td>
                <td>
                  <div className="user-cell">
                    <div className="user-cell-avatar">
                      <img src={b.avatar} alt={b.name} onError={(e) => { e.target.style.display = 'none'; e.target.parentElement.textContent = b.name.charAt(0); }} />
                    </div>
                    <div className="user-cell-info">
                      <span className="user-cell-name">{b.name}</span>
                      <span className="user-cell-email">{b.email}</span>
                    </div>
                  </div>
                </td>
                <td>
                  <div className="venue-cell">
                    <div className="venue-img">
                      <img src={b.venueImg} alt={b.venue} onError={(e) => { e.target.style.display = 'none'; e.target.parentElement.classList.add('venue-img-fallback'); e.target.parentElement.textContent = b.venue.charAt(0); }} />
                    </div>
                    <div className="venue-info">
                      <span className="venue-name">{b.venue}</span>
                      <span className="venue-location">
                       <img alt="Dashboard" class="menu-icon-img" src={`${process.env.PUBLIC_URL}/images/location-icon.svg`}></img>
                        {b.venueLocation}
                      </span>
                    </div>
                  </div>
                </td>
                <td>
                  <div className="datetime-cell">
                    <span className="datetime-date">{b.date}</span>
                    <span className="datetime-time">{b.time}</span>
                  </div>
                </td>
                <td>
                  <span className={`status-badge status-${b.status.toLowerCase()}`}>{b.status}</span>
                </td>
                <td>
                  <div className="actions-cell">
                    <button className="action-btn" title="View">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                        <circle cx="12" cy="12" r="3"/>
                      </svg>
                    </button>
                    <button className="action-btn" title="Edit">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
                        <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
                      </svg>
                    </button>
                    <button className="action-btn action-btn-danger" title="Delete">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="3 6 5 6 21 6"/>
                        <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
                      </svg>
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
